/**
 * Image utility - all images served from public/images folder
 * Placeholder fallbacks prevent broken images.
 */

// Base path for all product images
const IMG_BASE = process.env.PUBLIC_URL || '';

// Category-specific placeholder colors
const PLACEHOLDER_COLORS = {
  Jewelry: '#b8922a',
  'Hair Care': '#7a9e7e',
  Fashion: '#c17b8a',
  'Home & Gifts': '#8a7563',
  default: '#1a2744',
};

/**
 * Returns a safe image URL from the public/images folder.
 * Falls back to an SVG placeholder if the path is invalid.
 */
export function getImageUrl(path) {
  if (!path || typeof path !== 'string') return getPlaceholder();
  // Only allow paths starting with /images/
  if (!path.startsWith('/images/')) return getPlaceholder();
  // Prevent path traversal
  if (path.includes('..') || path.includes('//')) return getPlaceholder();
  return IMG_BASE + path;
}

/**
 * Returns an inline SVG placeholder as a data URL.
 */
export function getPlaceholder(category = 'default', text = 'No Image') {
  const color = PLACEHOLDER_COLORS[category] || PLACEHOLDER_COLORS.default;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400">
    <rect width="400" height="400" fill="${color}" opacity="0.15"/>
    <rect width="400" height="400" fill="none" stroke="${color}" stroke-width="2" opacity="0.3"/>
    <text x="200" y="185" text-anchor="middle" font-family="serif" font-size="14" fill="${color}" opacity="0.6">${text}</text>
    <text x="200" y="210" text-anchor="middle" font-family="serif" font-size="11" fill="${color}" opacity="0.4">Image Coming Soon</text>
  </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

/**
 * Returns all view angles for a product with safe URLs.
 */
export function getProductImages(product) {
  if (!product?.images) return {};
  return {
    front: getImageUrl(product.images.front),
    right: getImageUrl(product.images.right),
    left: getImageUrl(product.images.left),
    top: getImageUrl(product.images.top),
    detail: getImageUrl(product.images.detail),
  };
}

/**
 * Returns hero media - video or image from public/images/hero folder
 */
export function getHeroMedia(index, type = 'image') {
  if (type === 'video') {
    return `${IMG_BASE}/images/hero/hero-video.mp4`;
  }
  return getImageUrl(`/images/hero/hero-${index}.jpg`);
}

/**
 * Returns category image with safe path.
 */
export function getCategoryImage(slug) {
  return getImageUrl(`/images/categories/${slug}.jpg`);
}
